/**
 * @fileOverView
 * @description Header View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var HeaderTemplate = require('../../templates/widgets/header.html');
var AmpersandView = require('ampersand-view');
var app = require('ampersand-app');
var HeaderModel = require('../../models/header');

var HeaderView = AmpersandView.extend({

    template : HeaderTemplate,

    initialize: function(options){
        this.model = new HeaderModel(options);

        if(app.header!=undefined && app.header.get('mode')!=null){
            this.model.set('mode',app.header.get('mode'));
        }else if(window.localStorage.getItem('displayMode')!=null){
            this.model.set('mode',window.localStorage.getItem('displayMode'));
        }

        app.header = this.model;
    },

    bindings: {

        "model.maintitle" : {
            type: "text",
            selector: "div.maintitle"
        },

        "model.headerleft" : {
            type: "innerHTML",
            selector: "div.vheadleft"
        },

        "model.headerright" : {
            type: "innerHTML",
            selector: "div.vheadright"
        },

        "model.headerleftclass" : {
            type: "class",
            selector: "div.vheadleft"
        },

        "model.headerrightclass" : {
            type: "class",
            selector: "div.vheadright"
        },

        "model.headerclass" : {
            type: "class",
            selector: "header.vheader"
        }
    },

    events: {
        "click .vback" : "goBack",
        "click .vadd" : "add",
        "click .vmode" : "toggleMode",
        "click div.maintitle" : "clickMain",
        "click .vorgexit" : "exitOrgContext"
    },

    render: function(){
        this.renderWithTemplate();

        //the body class drives banner visibility and the header/scroll offsets.
        //Set here, not at app init, because rendering main.html replaces <body>.
        if(app.isManagingOrg()){
            var name = this.query('[data-hook=orgname]');
            if(name) name.textContent = app.auth.orgContext.name || app.auth.orgContext.key;
            document.body.classList.add('vorg-context');
        } else {
            document.body.classList.remove('vorg-context');
        }
        return this;
    },

    exitOrgContext: function(e){
        if(e) e.preventDefault();
        app.switchOrgContext(null);
    },

    goBack: function(){
        // When the page was loaded directly (e.g. a full navigation to
        // /subscription/<key> from /public) there's no in-SPA history to pop,
        // so app.lastPage is undefined and pageSwitcher.set would blank the
        // page. Fall back to the browser's back stack, then to the public
        // browse page. In-SPA flows still have app.lastPage and are unchanged.
        if(app.lastPage==undefined){
            if(window.history.length > 1) window.history.back();
            else window.location.href = "/public";
            return;
        }
        app.back = true;
        app.pageSwitcher.set(app.lastPage);
    },

    add: function(){
        if(this.model.ignoreclick){
            this.model.ignoreclick = false;
            return;
        }
        var pageview = {};
        pageview = new app.VybPageView({});
        app.pageSwitcher.set(pageview);
    },

    clickMain: function(){
        if(app.platform === 'app' && app.auth && app.auth.authenticated){
            app.reloadPageName = app.currentPageName;
            app.auth.checkAuth();
        }
    },

    toggleMode: function(){
        var mode = this.model.get('mode')=="day" ? "night" : "day";
        window.localStorage.setItem('displayMode',mode);
        this.model.set('mode', mode);
        app.utils.setDisplayMode();
    }

});

module.exports = HeaderView;
